import React from "react";
import Card from "../components/Card";
import BroadbandCard from "../components/BroadbandCard";

export default function Broadband({ isVisible, network }) {
  //Hooks
  //const broadband = useGetBroadband();

  return (
    <div className={isVisible ? "tel-pt-broadband" : "tel-pt-broadband not-visible"}>
      <p className="tel-pt-view-description">Välj ditt bredbandsalternativ.</p>
      {network.bredband &&
        network.bredband.map((broadband: any) => {
          if (broadband) return <BroadbandCard data={broadband} />;

          return null;
        })}
      {!network.bredband && <h2 className="tel-p-form__no-product-text">Inga tillgängliga bredband</h2>}
    </div>
  );
}
